// C:\Ava_Local\Ava_API\avaai_dashboard\frontend\src\pages\education\MultiplicationPage.tsx
import React from "react";
import TutorPage from "./TutorPage";

export default function MultiplicationPage() {
  return <TutorPage initialTopic="Multiplication" lockTopic />;
}